module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-wrapper",
    class: _vm.classObj
  }, [(_vm.device === 'mobile' && _vm.sidebar.opened) ? _c('div', {
    staticClass: "drawer-bg",
    on: {
      "click": _vm.handleClickOutside
    }
  }) : _vm._e(), _vm._v(" "), _c('sidebar', {
    staticClass: "sidebar-container"
  }), _vm._v(" "), _c('div', {
    staticClass: "main-container"
  }, [_c('navbar'), _vm._v(" "), _c('app-main')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a4d0a1d","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/Layout.vue
// module id = IX2s
// module chunks = 3